/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Set_Without_MeasureInputs */

const en_us2_workout_set_without_measure = /** @type {(inputs: Workout_Set_Without_MeasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A set needs reps, time or distance.`)
};

const pt_br2_workout_set_without_measure = /** @type {(inputs: Workout_Set_Without_MeasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma série precisa de repetições, tempo ou distância.`)
};

const es_419_workout_set_without_measure = /** @type {(inputs: Workout_Set_Without_MeasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una serie necesita repeticiones, tiempo o distancia.`)
};

const pt_pt2_workout_set_without_measure = /** @type {(inputs: Workout_Set_Without_MeasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma série precisa de repetições, tempo ou distância.`)
};

const fr_fr2_workout_set_without_measure = /** @type {(inputs: Workout_Set_Without_MeasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indique des répétitions, une durée ou une distance.`)
};

const de_de2_workout_set_without_measure = /** @type {(inputs: Workout_Set_Without_MeasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Satz braucht Wiederholungen, Zeit oder Strecke.`)
};

const it_it2_workout_set_without_measure = /** @type {(inputs: Workout_Set_Without_MeasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una serie ha bisogno di ripetizioni, tempo o distanza.`)
};

/**
* | output |
* | --- |
* | "A set needs reps, time or distance." |
*
* @param {Workout_Set_Without_MeasureInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_set_without_measure = /** @type {((inputs?: Workout_Set_Without_MeasureInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Set_Without_MeasureInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_set_without_measure(inputs)
	if (locale === "es-419") return es_419_workout_set_without_measure(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_set_without_measure(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_set_without_measure(inputs)
	if (locale === "de-DE") return de_de2_workout_set_without_measure(inputs)
	if (locale === "it-IT") return it_it2_workout_set_without_measure(inputs)
	return en_us2_workout_set_without_measure(inputs)
});
export { workout_set_without_measure as "workout.set_without_measure" }